import { useState } from 'react'
import EditLine from '../../../components/admin/EditLine'
import { useAuth } from '../../../hooks/useAuth'

export const pageTitle = 'Account Details'

export enum FocusableElement {
  LabelTitle = 'label-title',
  EditLineName = 'edit-line-name',
  EditLineEmail = 'edit-line-email',
  EditLinePassword = 'edit-line-password'
}

const AccountDetails: React.FunctionComponent = () => {
  const { userProfile } = useAuth()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [disabled, setDisabled] = useState(false)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isEditing, setIsEditing] = useState(false)

  return (
    <div className='flex flex-col h-full'>
      <div className='flex justify-between px-[45px] md:px-[45px] px-6 py-[51px] md:py-[51px] py-6 items-center'>
        <h1
          id={FocusableElement.LabelTitle}
          className='text-[72px] md:text-[72px] text-[48px] font-bold text-[rgba(52,232,158,0.75)]'
        >
          {pageTitle}
        </h1>
      </div>
      <div className='px-[45px] md:px-[45px] px-6 flex-1'>
        <EditLine
          id={FocusableElement.EditLineName}
          isEditable={false}
          label='Name'
          value={userProfile !== null ? `${userProfile.first_name} ${userProfile.last_name}` : ''}
          isSentryMasked
        />
        <EditLine
          id={FocusableElement.EditLineEmail}
          label='Email address'
          value={userProfile !== null ? userProfile.email : ''}
          isSentryMasked
        />
        <EditLine
          id={FocusableElement.EditLinePassword}
          isEditable
          label='Password'
          onPasswordSave={() => setDisabled(true)}
          onPasswordSaveComplete={() => {
            setDisabled(false)
            setIsEditing(false)
          }}
          type='password'
          value='********'
          setEditing={setIsEditing}
        />
        {/*
        // temporarily commented out for MVP https://dopage.atlassian.net/browse/DMVP-201
        {
          userProfile?.role?.slug === 'admin'
            ? <EditLine label='Job Title' value={userProfile !== null ? userProfile?.user_profile.job_title : ''} />
            : <EditLine label='Year in School' value={userProfile !== null ? userProfile?.user_profile.school_year : ''} />
        } */}

      </div>
    </div>
  )
}

export default AccountDetails
